//@flow
/**
 * Registers a service worker, if available and in production.
 * @memberof registerServiceWorker
 */
export default function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${String(process.env.PUBLIC_URL)}/service-worker.js`
      if (navigator.serviceWorker) {
        navigator.serviceWorker
          .register(swUrl)
          .then(registration => {
            registration.onupdatefound = () => {
              const installingWorker = registration.installing
              installingWorker.onstatechange = () => {
                if (
                  installingWorker.state === 'installed' &&
                  navigator.serviceWorker
                ) {
                  if (navigator.serviceWorker.controller) {
                    // At this point, the old content will have been purged and
                    // the fresh content will have been added to the cache.
                    // It's the perfect time to display a "New content is
                    // available; please refresh." message in your web app.
                  } else {
                    // At this point, everything has been precached.
                    // It's the perfect time to display a
                    // "Content is cached for offline use." message.
                  }
                }
              }
            }
          })
          .catch(error => {
            console.error('Error during service worker registration:', error)
          })
      }
    })
  }
}

/**
 * Unregisters a service worker.
 * @memberof registerServiceWorker
 */
export function unregister() {
  if (navigator.serviceWorker) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js